import { Navigate } from "react-router-dom";
import { ManageProtectedRoute } from "./common/manage-protected-route";

export const MANAGE_ROUTE = [
  {
    path: "/manage/*",
    element: <ManageProtectedRoute />,
    children: [
      {
        index: true,
        element: <Navigate to="normalization" replace />,
      },
      {
        path: "normalization",
        lazy: () => import("./normalization/normalization-list"),
      },
      {
        path: "normalization/edit",
        lazy: () => import("./normalization/normalization-edit"),
      },
      {
        path: "network",
        lazy: () => import("./network/network-list"),
      },
      {
        path: "network/edit/:id?",
        lazy: () => import("./network/network-edit"),
      },
      {
        path: "devices",
        lazy: () => import("./devices/manage-device-list"),
      },
    ],
  },
];
